import { Grid, Typography } from "@mui/material";


const Zelle = () => {

    return (
        <Grid container direction="column" spacing={2}>
            <Grid item>
                <Typography variant="h6">How to make a payment with Zelle</Typography>
            </Grid>
            <Grid item>
                <Typography>1) Please head to your bank's website and add <span style={{fontWeight: 'bold'}}>info@thenextfunthing.com</span> as a recipient. </Typography>
            </Grid>
            <Grid item>
                <Typography>2) Please make a payment referencing the invoice number. If you are paying off multiple invoices, please enter in each invoice number seperated by a comma </Typography>
            </Grid>
            <Grid item>
                <Typography>Your invoice will be marked as 'paid' within 24 hours.</Typography>
            </Grid>
        </Grid>
    )


}

export default Zelle;